import { css } from "@emotion/css";
import { mergeProps } from "react-aria";
import {
  DateSegment as AriaDateSegment,
  DateSegmentProps,
  DateSegmentRenderProps,
  useLocale,
} from "react-aria-components";

import { getTextStyle } from "@certn/cascadia-react/foundations/typography/styles";

import { _Text } from "../../../_assets/_Text";
import { useInputStyles } from "../../styles";
import { getDisplayNames } from "../utils";

export function _DateSegment(props: DateSegmentProps) {
  const { locale } = useLocale();
  const style = useInputStyles();

  const displayNames = getDisplayNames(locale);

  const className = css(
    style,
    styles.input,
    props.segment.type === "year" && { width: 72 }
  );

  if (props.segment.type === "literal") {
    return null;
  }

  if (!props.segment.isEditable) {
    return (
      <AriaDateSegment
        {...mergeProps(props, {
          className: css(
            {
              alignSelf: "flex-end",
              paddingBottom: "var(--space-2)",
              paddingTop: "var(--space-2)",
            },

            getTextStyle("input/text-field")
          ),
        })}
      />
    );
  }

  return (
    <div className={styles.segment}>
      <_Text style="input/helper" color="text-weak">
        {displayNames
          ? displayNames.of(props.segment.type)
          : props.segment.type}
      </_Text>
      <AriaDateSegment
        {...mergeProps(props, {
          className: (renderProps: DateSegmentRenderProps) =>
            css(
              className,
              renderProps.isPlaceholder && {
                color: "var(--text-weak)",
                textTransform: "uppercase",
              }
            ),
        })}
      />
    </div>
  );
}

const styles = {
  segment: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-1)",
    "> span:first-child": {
      textTransform: "capitalize",
    },
  }),
  input: css({
    "&[data-focused]&[data-placeholder]": { color: "transparent" },
    caretColor: "transparent",
    width: 52,
  }),
};
